<template>
  <Loader v-if="loading"/>
  <div v-else class="mt-8">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-3xl">{{ $lang.app.INBOX }}</h2>
      <div class="flex">
        <button @click="$router.go(-1)"
                class="flex items-center pl-3 pr-4 py-2 text-sm text-center text-white bg-indigo-600 rounded-md focus:outline-none hover:bg-indigo-500">
          <ArrowLeftIcon class="w-4 h-4 mr-2"/>
          {{ $lang.app.BACK }}
        </button>
      </div>
    </div>
    <div class="bg-white rounded-lg p-4">
      <div class="flex justify-between">
        <div class="flex items-center">
          <UserCircleIcon class="w-16 h-16 text-indigo-500 flex-shrink-0"/>
          <div class="text-gary-900 font-medium px-2">
            <p> {{ inbox.fromUser?.userInfo?.fullName }}
              <span class="font-normal text-gray-600 ml-4">{{ inbox.fromUser?.login }}</span>
            </p>
            <p> {{ $lang.app.TO_ME }} <span class="font-normal text-gray-600 ml-4">{{ inbox.toUser?.login }}</span></p>
          </div>
        </div>
        <div>
          {{ $moment(inbox.createdAt).format('LLLL') }}
        </div>
      </div>
      <div class="ml-16 p-2">
        <div class="mb-6">
          <h3 class="font-medium text-lg">{{ inbox.title }}</h3>
          <p>{{ inbox.message }}</p>
        </div>
        <Actions :inbox="inbox"/>
      </div>
    </div>
  </div>
</template>
<script>
import requestApi from "../../../../api/applicant/request";
import Actions from "../../../../components/applicant/inbox/Actions.vue";

export default {
  components: {
    Actions
  },
  data() {
    return {
      loading: false,
      inbox: null,
    }
  },
  created() {
    this.fetchInbox()
  },
  methods: {
    fetchInbox() {
      this.loading = true
      requestApi.getRequest(this.$route.params.inboxId).then(res => {
        this.inbox = res
        this.$emitter.emit('update-sidebar-badges')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>